export default __webpack_public_path__ + "static/media/food.807dfee5.jpeg";